import { Box, FormControl, FormControlLabel, Checkbox, RadioGroup, Radio, Paper } from '@mui/material';

const QuizOptions = ({ options, questionType, isOptionSelected, handleOptionChange, lockedQuestions, currentQuestionIndex, getOptionClass, selectedAnswers, lngsltd }) => {
    // Ensure that selectedAnswers[currentQuestionIndex] is initialized
    const currentSelection = selectedAnswers[currentQuestionIndex] || [];
    const isLocked = lockedQuestions.includes(currentQuestionIndex);
    
    return(
    <FormControl component="fieldset" sx={{ width: '100%' }}>
        {questionType === 'Multiple Choice' ? (
            <Box display="flex" flexDirection="column" gap={1.5}>
                {options.map((option, index) => (
                    <Paper
                        key={index}
                        elevation={0}
                        onClick={(e) => {
                            if (!isLocked) {
                                handleOptionChange(e, option);
                            }
                        }}
                        sx={{
                            border: '2px solid',
                            borderColor: currentSelection.includes(option) 
                                ? (getOptionClass(option).includes('correct-answer') ? '#10b981' : getOptionClass(option).includes('wrong-answer') ? '#ef4444' : '#dc3545')
                                : '#e5e7eb',
                            borderRadius: '12px',
                            backgroundColor: currentSelection.includes(option)
                                ? (getOptionClass(option).includes('correct-answer') ? 'rgba(16, 185, 129, 0.1)' : getOptionClass(option).includes('wrong-answer') ? 'rgba(239, 68, 68, 0.1)' : 'rgba(220, 53, 69, 0.05)')
                                : '#ffffff',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                borderColor: isLocked ? undefined : '#dc3545',
                                backgroundColor: isLocked ? undefined : 'rgba(220, 53, 69, 0.03)',
                                transform: isLocked ? undefined : 'translateY(-2px)',
                                boxShadow: isLocked ? undefined : '0 4px 12px rgba(0, 0, 0, 0.08)'
                            },
                            cursor: isLocked ? 'default' : 'pointer'
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={currentSelection.includes(option)}
                                    onChange={(e) => handleOptionChange(e, option)}
                                    disabled={isLocked}
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{
                                        color: getOptionClass(option).includes('correct-answer') ? '#10b981' : getOptionClass(option).includes('wrong-answer') ? '#ef4444' : '#dc3545',
                                        '&.Mui-checked': {
                                            color: getOptionClass(option).includes('correct-answer') ? '#10b981' : getOptionClass(option).includes('wrong-answer') ? '#ef4444' : '#dc3545'
                                        },
                                        pointerEvents: 'auto'
                                    }}
                                />
                            }
                            label={
                                <span 
                                    className={getOptionClass(option)} 
                                    style={{
                                        fontSize: '1rem',
                                        fontWeight: currentSelection.includes(option) ? 500 : 400,
                                        padding: '12px 8px',
                                        display: 'block',
                                        width: '100%',
                                        pointerEvents: 'none'
                                    }}
                                >
                                    {option}
                                </span>
                            }
                            labelPlacement="end"
                            sx={{ 
                                m: 0,
                                width: '100%',
                                pointerEvents: 'none',
                                '& .MuiFormControlLabel-label': {
                                    width: '100%',
                                    pointerEvents: 'none'
                                }
                            }}
                        />
                    </Paper>
                ))}
            </Box>
        ) : (
            <RadioGroup
                value={currentSelection[0] || ''}
                onChange={(e) => handleOptionChange(e, e.target.value)}
                sx={{ gap: 1.5 }}
            >
                {options.map((option, index) => (
                    <Paper
                        key={index}
                        elevation={0}
                        onClick={(e) => {
                            if (!isLocked) {
                                // Create a synthetic event to trigger the RadioGroup onChange
                                const syntheticEvent = {
                                    target: { value: option },
                                    preventDefault: () => {},
                                    stopPropagation: () => {}
                                };
                                handleOptionChange(syntheticEvent, option);
                            }
                        }}
                        sx={{
                            border: '2px solid',
                            borderColor: currentSelection[0] === option
                                ? (getOptionClass(option).includes('correct-answer') ? '#10b981' : getOptionClass(option).includes('wrong-answer') ? '#ef4444' : '#dc3545')
                                : '#e5e7eb',
                            borderRadius: '12px',
                            backgroundColor: currentSelection[0] === option
                                ? (getOptionClass(option).includes('correct-answer') ? 'rgba(16, 185, 129, 0.1)' : getOptionClass(option).includes('wrong-answer') ? 'rgba(239, 68, 68, 0.1)' : 'rgba(220, 53, 69, 0.05)')
                                : '#ffffff',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                borderColor: isLocked ? undefined : '#dc3545',
                                backgroundColor: isLocked ? undefined : 'rgba(220, 53, 69, 0.03)',
                                transform: isLocked ? undefined : 'translateY(-2px)',
                                boxShadow: isLocked ? undefined : '0 4px 12px rgba(0, 0, 0, 0.08)'
                            },
                            cursor: isLocked ? 'default' : 'pointer'
                        }}
                    >
                        <FormControlLabel
                            value={option}
                            control={
                                <Radio 
                                    disabled={isLocked}
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{
                                        color: getOptionClass(option).includes('correct-answer') ? '#10b981' : getOptionClass(option).includes('wrong-answer') ? '#ef4444' : '#dc3545',
                                        '&.Mui-checked': {
                                            color: getOptionClass(option).includes('correct-answer') ? '#10b981' : getOptionClass(option).includes('wrong-answer') ? '#ef4444' : '#dc3545'
                                        },
                                        pointerEvents: 'auto'
                                    }}
                                />
                            }
                            label={
                                <span 
                                    className={getOptionClass(option)} 
                                    style={{
                                        fontSize: '1rem',
                                        fontWeight: currentSelection[0] === option ? 500 : 400,
                                        padding: '12px 8px',
                                        display: 'block',
                                        width: '100%',
                                        pointerEvents: 'none'
                                    }}
                                >
                                    {option}
                                </span>
                            }
                            labelPlacement="end"
                            sx={{ 
                                m: 0,
                                width: '100%',
                                pointerEvents: 'none',
                                '& .MuiFormControlLabel-label': {
                                    width: '100%',
                                    pointerEvents: 'none'
                                }
                            }}
                        />
                    </Paper>
                ))}
            </RadioGroup>
        )}
    </FormControl>
);
};

export default QuizOptions;
